import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { mobilitySurveyTransportModes } from '../../models';
import StatsCard from './stats-card';
export const transportHabitsTransportModesMap = {
  car: {
    labelKey: 'commons.transport_habits.transport_modes.car'
  },
  carpooling: {
    labelKey: 'commons.transport_habits.transport_modes.carpooling'
  },
  publicTransport: {
    labelKey: 'commons.transport_habits.transport_modes.public_transports',
    captionKey: 'commons.transport_habits.transport_modes.public_transports_caption'
  },
  walk: {
    labelKey: 'commons.transport_habits.transport_modes.walk',
    captionKey: 'commons.transport_habits.transport_modes.walk_caption'
  },
  bicycle: {
    labelKey: 'commons.transport_habits.transport_modes.bicycle'
  },
  scooter: {
    labelKey: 'commons.transport_habits.transport_modes.scooter',
    captionKey: 'commons.transport_habits.transport_modes.scooter_caption'
  },
  motorbike: {
    labelKey: 'commons.transport_habits.transport_modes.motorbike'
  }
};
export function TransportHabitsTransportModes({
  progressBarWidth,
  stats
}) {
  const [items, setItems] = useState();
  const {
    t
  } = useTranslation();
  useEffect(() => {
    setItems(stats ? mobilitySurveyTransportModes.map(key => {
      const {
        labelKey,
        captionKey
      } = transportHabitsTransportModesMap[key];
      return {
        key,
        label: t(labelKey),
        caption: captionKey ? t(captionKey) : undefined,
        count: stats.transportModes[key] || 0
      };
    }).sort((a, b) => b.count - a.count) : undefined);
  }, [stats]);
  return /*#__PURE__*/React.createElement(StatsCard, {
    items: items,
    progressBarColor: "#528be8",
    progressBarWidth: progressBarWidth,
    respondantsCount: stats?.respondantsCount,
    title: t('commons.transport_habits.transport_modes.title')
  });
}